// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ql-font-serif {
  font-family: Georgia, Times New Roman, serif;
}
.ql-font-monospace {
  font-family: Monaco, Courier New, monospace;
}

.ql-align-center {
  text-align: center;
}
.ql-align-left {
  text-align: left;
}
.ql-align-justify {
  text-align: justify;
}
.ql-align-right {
  text-align: right;
}

.ql-size-huge {
  font-size: 2.5em;
}
.ql-size-small {
  font-size: 0.75em;
}
.ql-size-large {
  font-size: 1.5em;
}
`, "",{"version":3,"sources":["webpack://./src/components/GeneralMessagePreview/CustomNotificationPreviewEmail.css"],"names":[],"mappings":"AAAA;EACE,4CAA4C;AAC9C;AACA;EACE,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".ql-font-serif {\n  font-family: Georgia, Times New Roman, serif;\n}\n.ql-font-monospace {\n  font-family: Monaco, Courier New, monospace;\n}\n\n.ql-align-center {\n  text-align: center;\n}\n.ql-align-left {\n  text-align: left;\n}\n.ql-align-justify {\n  text-align: justify;\n}\n.ql-align-right {\n  text-align: right;\n}\n\n.ql-size-huge {\n  font-size: 2.5em;\n}\n.ql-size-small {\n  font-size: 0.75em;\n}\n.ql-size-large {\n  font-size: 1.5em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
